import tippy, { followCursor } from 'tippy.js';
export default function () {

    tippy('[data-balloon]', {
        theme: 'light-border',
        allowHTML: true,
        animation: 'scale',
        content(reference) {
            return reference.getAttribute('data-balloon');
        },
    });

    tippy('[data-admin-popup]:not([data-admin-popup=""])', {
        theme: 'light-border',
        animation: 'scale',
        allowHTML: true,
        maxWidth: 'none',
        plugins: [followCursor],
        followCursor: 'horizontal',
        content: "Ładowanie",
        onShow(instance) {
            const admin = instance.reference.getAttribute('data-admin-popup');
           
            fetch("/_admin/Utils/AdminTooltip.aspx?id=" + admin)
                .then((response) => response.text())
                .then((text) => {
                    instance.setContent(text);
                    window.lazyLoadInstance.update();
                })
        },
    });

    tippy('.trigger-product-popup', {
        theme: 'light-border',
        interactive: true,
        animation: 'scale',
        allowHTML: true,
        maxWidth: 'none',
        plugins: [followCursor],
        followCursor: 'horizontal',
        content: "Ładowanie",
        onShow(instance) {
            const oid = instance.reference.getAttribute('data-oid');
            const pid = instance.reference.getAttribute('data-pid');
            fetch("/_admin/Products/ProductTooltip.aspx?id=" + pid + "&oid=" + oid)
                .then((response) => response.text())
                .then((text) => {
                    instance.setContent(text);
                    window.lazyLoadInstance.update();
                })
        },
    });

    tippy('.trigger-order-popup', {
        theme: 'light-border',
        interactive: true,
        animation: 'scale',
        allowHTML: true,
        maxWidth: 'none',
        content: "Ładowanie",
        appendTo: document.body,
        onShow(instance) {
            const oid = instance.reference.getAttribute('data-oid');

            fetch("/_admin/Orders/OrderDetailsSmall.aspx?id=" + oid)
                .then((response) => response.text())
                .then((text) => {
                    instance.setContent(text);
                    window.lazyLoadInstance.update();
                })
        },
    });

    tippy('.tagline strong', {
        theme: 'light-border',
        animation: 'scale',
        allowHTML: true,
        content(reference) {
            const title = reference.getAttribute('data-tag-info')
            return title
        },
    });

    tippy('.show-tooltip-next', {
        theme: 'light-border',
        plugins: [followCursor],
        followCursor: 'horizontal',
        animation: 'scale',
        allowHTML: true,
        content(reference) {
            return $(reference).next().html();
        },
    });
}